// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const emolga: PokeData = {
  "id": 587,
  "name": "emolga",
  "height": 4,
  "weight": 50,
  "base_experience": 150,
  "types": [
    PokeType.ELECTRIC,
    PokeType.FLYING
  ],
  "api_moves": [
    "tail-whip",
    "thunder-shock",
    "agility",
    "quick-attack",
    "double-team",
    "light-screen",
    "spark",
    "encore",
    "pursuit",
    "charge",
    "shock-wave",
    "discharge",
    "electro-ball",
    "acrobatics",
    "volt-switch",
    "nuzzle"
  ],
  "moves": [
    "thunder-shock",
    "quick-attack",
    "pursuit",
    "acrobatics",
    "volt-switch",
    "sky-attack",
    "zap-cannon",
    "thunder-fang",
    "quick-tempo",
    "air-slash",
    "brave-bird",
    "roost",
    "volt-crash"
  ],
  "evolution_chain": {
    "id": 298,
    "item": null,
    "species": [
      {
        "name": "emolga",
        "order": 588,
        "types": [
          PokeType.ELECTRIC,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 98,
    "speed": 175,
    "ability_power": 127
  },
  "stat_changes": [],
  "catch_rate": 200,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
